module.exports = "<app-accountmaster-menu></app-accountmaster-menu>\n<p>\n  account-closure works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/accountmaster/account-closure/account-closure.component.html
// module id = ./src/app/accountmaster/account-closure/account-closure.component.html
// module chunks = main